import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  TdDataTableService,
  TdDataTableSortingOrder,
  ITdDataTableSortChangeEvent,
  ITdDataTableColumn,
  TdDialogService,
  IPageChangeEvent,
  TdLoadingService
} from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { InventoryService } from '../../../inventory/inventory.service';
import { SettingsService } from '../../../../shared/services/settings.service';
import { Branch } from '../../../accounting/branch';
import { Observable } from 'rxjs/Observable';
import { Utils } from '../../../../shared/utils';

import { LocationService } from 'services/location.service';


@Component({
  selector: 'app-multi-select-change-loc',
  templateUrl: './multi-select-change-loc.component.html',
  styleUrls: ['./multi-select-change-loc.component.scss']
})
export class MultiSelectChangeLocComponent implements OnInit {
  title: string;
  itemLocation: any;
  items: any[] = [];

  locations: any[] = [];


  //For the movement
  pieceNumber: any;
  newLocation: any;


  allBranches$: Observable<Branch[]>;

  branchFilter: number;

  columns: ITdDataTableColumn[] = [
    { name: 'collection_name', label: 'Collection', tooltip: '' },
    { name: 'design_name', label: 'Design', tooltip: '' },
    { name: 'color_name', label: 'Color', tooltip: '' },
    { name: 'length', label: 'Meters' },
    { name: 'piece_number', label: 'Piece Number', tooltip: '' },
    { name: 'lot_number', label: 'Lot Number' }
  ];


  filteredData: any[] = [];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dialogService: TdDialogService,
    public _settingsService: SettingsService,
    private _dataTableService: TdDataTableService,
    private location: Location,
    private _loadingService: TdLoadingService,
    public _authService: AuthenticationService,
    private _inventoryService: InventoryService,
    private _locationService: LocationService
  ) { }

  ngOnInit(): void {
    this.branchFilter = this._authService.getUserBranches().find(b => { return b.id == this._authService.getHomeBranch() }).id;
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
    this.getLocations();
  }

  goBack(): void {
    this.location.back();
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  findItems(location: string): void {
    this.selectedRows = [];

    if (this.locations.find((l) => { return l.name == location }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The location that you scanned is not registered in your home branch'
      });
      return;
    }

    this._loadingService.register('loading');
    this._inventoryService.findByLocation(location, this.branchFilter).subscribe(
      response => {
        this.items = response;
        console.log(this.items)
        this.filter();
        this._loadingService.resolve('loading');
      }
    );
  }

  totalPieces() {
    return this.items.length;
  }

  totalMeters() {
    return this.filteredData.reduce((a, b) => { return a * 1 + b['length'] * 1 }, 0).toFixed(3);
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.items;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;

    if (this.filteredTotal < 1) {
      this._dialogService.openAlert({
        message: 'No matching location found or location is empty!',
        title: 'Error'
      });
    }
  }


  //CHECKBOX----
  select(selected: boolean, row) {


    if (selected) {
      if (!this.selectedRows.some(item => { return item["piece_number"] == row["piece_number"] })) {
        this.selectedRows.push(row);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(item => { return item["piece_number"] != row["piece_number"] })
    }
    console.log(this.selectedRows);
  }


  rowSelected(row) {
    return this.selectedRows.some((selected) => { return selected["piece_number"] == row["piece_number"] });
  }


  allSelected() {
    // Are there as many selected as there are in the list?
    return this.filteredData.length == this.selectedRows.length;
  }



  selectAll() {
    let selected = !this.allSelected();
    //let selected= !(this.filteredData.length == this.selectedRows.length);

    if (selected) {
      this.filteredData.forEach(
        item => {
          this.select(true, item);
        }
      );
    } else {
      this.selectedRows = [];
    }

  }




  //END CHECKBOX---------

  //CHANGE LOCATION--------
  getLocations() {
    this._locationService.getLocations(this._authService.getHomeBranch() + '').subscribe(
      response => {
        this.locations = response;
      }
    );
  }


  sentMessage: string = '';
  errorMessage: string = '';
  hasNoPieceNumber: boolean = false;

  changeLocation(): void {
    // If location is not in the list


    if(this.selectedRows.length==0){
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'There is nothing selected!'
      });
      return;
    }else 
    if (this.locations.find((l) => { return l.name == this.newLocation }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The location that you scanned is not registered in your home branch'
      });
      return;
    } else if (this.itemLocation == this.newLocation) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The location can not be the same!'
      });
      return;
    } else if (this.selectedRows.length > 0) {
      this._loadingService.register('loading');
    }

    for (let i = 0; i < this.selectedRows.length; i++) {

      let pieceNumber = this.selectedRows[i]["piece_number"];

      if (pieceNumber == "undefined") {
        this.hasNoPieceNumber = true;
        continue;
      }

      if (pieceNumber) {
        this._inventoryService.changeLocation(pieceNumber, this.newLocation, this.branchFilter).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.sentMessage += pieceNumber + '|';

              // this._dialogService.openAlert({
              //   message: 'Piece number ' + this.selectedRows[i]["piece_number"] + ' was sent successfully!',
              //   title: 'Success'
              // }).afterClosed().subscribe(r => this.goBack());


            } else {
              this.errorMessage += pieceNumber + '|';

              // this._dialogService.openAlert({
              //   message: 'Could not change piece location of piece number'+this.selectedRows[i]["piece_number"],
              //   title: 'Error'
              // });
            }

            if (i == this.selectedRows.length - 1) {
              this._loadingService.resolve('loading');
              this.alertSuccess();
            }
          }
        );
      } else {
        this.hasNoPieceNumber = true;
      }
    }

  }

  alertSuccess(): void {
    this.errorMessage = this.errorMessage.slice(0, -1);
    this.sentMessage = this.sentMessage.slice(0, -1);

    if (this.errorMessage) {
      if (this.sentMessage) {//Case error +success
        this._dialogService.openAlert({
          message: 'Pieces numbers:' + this.sentMessage + ' were sent successfully!',
          title: 'Success'
        }).afterClosed().subscribe(r => this.goBack());

        this._dialogService.openAlert({
          message: 'Could not change location of the following pieces:' + this.errorMessage,
          title: 'Error'
        });
      } else {//Case only error
        this._dialogService.openAlert({
          message: 'Could not change location of the following pieces:' + this.errorMessage,
          title: 'Error'
        }).afterClosed().subscribe(r => this.goBack());
      }

    } else if (this.sentMessage) {//Case only success
      this._dialogService.openAlert({
        message: 'Pieces numbers:' + this.sentMessage + ' were sent successfully!',
        title: 'Success'
      }).afterClosed().subscribe(r => this.goBack());
    }



    if (this.hasNoPieceNumber) {
      if (this.errorMessage || this.sentMessage) {
        this._dialogService.openAlert({
          message: 'Some pieces does not have a Piece Number!',
          title: 'Error'
        });
      } else {//Case no piece has number
        this._dialogService.openAlert({
          message: 'Some pieces does not have a Piece Number!',
          title: 'Error'
        }).afterClosed().subscribe(r => this.goBack());
      }
    }

    this.sentMessage = '';
    this.errorMessage = '';
    this.hasNoPieceNumber = false;

  }

  //END CHANGE LOCATION--------


}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/multi-select-change-loc/multi-select-change-loc.component.ts